import { TABLE_FILTER_LIKE } from './constants.js';

export const filterIgnoreAccents = (value, filterValue) => {
  const normalizeString = (str) =>
    str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  const rowValueNormalized = normalizeString(value);
  const filterValueNormalized = normalizeString(filterValue);

  return rowValueNormalized.includes(filterValueNormalized);
};

/**
 * Builds a query string pair with the value encoded, so that characters such as
 * `+`, `&`, `#` or `%` in searched/filtered values reach the API untouched.
 */
export const filterQs = (key, value) => `${key}=${encodeURIComponent(value)}`;

export const filterParams = (table) => {
  const pagination = table.getState().pagination;
  const sorting = table.getState().sorting;
  const columnFilters = table.getState().columnFilters;

  let filters = '';
  let filtersArr = [];
  let sort = '';

  if (sorting.length) {
    let { id, desc } = sorting[0];
    // For Coupons Index Page - Start
    if (id === 'codeNumber') id = 'codeNumberInt';
    // For Coupons Index Page - End
    sort = `&order_by=${id},${desc ? 'desc' : 'asc'}`;
  }

  if (columnFilters?.length) {
    for (const filter of columnFilters) {
      const column = table.getColumn(filter.id);

      if (!column) continue;

      const { filterType } = column.columnDef;
      if (filterType === TABLE_FILTER_LIKE.RIGHT) {
        filtersArr.push(filterQs(filter.id, `like:${filter.value}*`));
      } else if (filterType === TABLE_FILTER_LIKE.LEFT) {
        filtersArr.push(filterQs(filter.id, `like:*${filter.value}`));
      } else if (filterType === TABLE_FILTER_LIKE.BOTH) {
        filtersArr.push(filterQs(filter.id, `like:*${filter.value}*`));
      } else if (filterType === TABLE_FILTER_LIKE.IN) {
        filtersArr.push(filterQs(filter.id, `in:${filter.value}`));
      } else {
        filtersArr.push(filterQs(filter.id, filter.value));
      }
    }

    filters = `${filtersArr.join('&')}&`;
  }

  // filters += `limit=${(pagination.pageIndex + 1) * pagination.pageSize}&offset=${pagination.pageIndex * pagination.pageSize}`;
  filters += `limit=${pagination.pageSize}&offset=${pagination.pageIndex * pagination.pageSize + 1}`;

  if (!filters && !sort) return '';

  return `${filters}${sort}`;
};
